import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-pdpa-ndid',
  templateUrl: './pdpa-ndid.component.html',
  styleUrls: ['../pdpa-policy/pdpa-policy.component.css'],
})
export class PdpaNdidComponent implements OnInit {
  lang: string;
  @Input() consent = false;
  @Output() acceptChange = new EventEmitter<any>();

  ngOnInit(): void {
    this.lang = localStorage.getItem('lang') || 'en';
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 100);
  }

   onAcceptChange(chkAgree: any) {
      this.acceptChange.emit(chkAgree);
   }
}
